import { request } from '../http';

export type CustomerActivityItem = {
  id: string;
  category: string;
  type: string;
  titleKey?: string | null;
  summaryKey?: string | null;
  title?: string | null;
  summary?: string | null;
  titleParams?: Record<string, unknown>;
  summaryParams?: Record<string, unknown>;
  severity: string;
  actor?: { userId?: string | null; name?: string | null; email?: string | null } | null;
  organization?: Record<string, unknown> | null;
  search?: { id?: string | null; name?: string | null; title?: string | null; url?: string | null } | null;
  recipient?: { id?: string | null; name?: string | null } | null;
  listing?: { id?: string | null; title?: string | null; url?: string | null } | null;
  status?: string | null;
  createdAt?: string | null;
  link?: string | null;
  metadata?: Record<string, unknown>;
  read: boolean;
  attention?: boolean;
};

export type CustomerActivityList = {
  items: CustomerActivityItem[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    pages: number;
    hasMore: boolean;
    nextCursor?: string | null;
  };
  summary: {
    unreadCount: number;
    byCategory: Record<string, number>;
  };
};

export type CustomerActivityPreferences = {
  categories: string[];
  showTeamEvents: boolean;
  showSubscriptionEvents: boolean;
  digestEnabled: boolean;
};

function buildQuery(params?: Record<string, string | number | boolean | undefined | null>) {
  const q = new URLSearchParams();
  if (!params) return '';
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.set(k, String(v));
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const customerActivityService = {
  list(params?: {
    page?: number;
    page_size?: number;
    category?: string;
    search_id?: string;
    date_from?: string;
    date_to?: string;
    severity?: string;
    unread_only?: boolean;
    mine_only?: boolean;
    cursor?: string;
  }) {
    return request<CustomerActivityList>(`/customer-activity${buildQuery(params)}`);
  },

  attention() {
    return request<CustomerActivityItem[]>('/customer-activity/attention');
  },

  unreadCount() {
    return request<{ unreadCount: number }>('/customer-activity/unread-count');
  },

  markRead(id: string) {
    return request<{ ok: boolean }>(`/customer-activity/${encodeURIComponent(id)}/read`, {
      method: 'POST',
    });
  },

  markAllRead() {
    return request<{ marked: number }>('/customer-activity/read-all', { method: 'POST' });
  },

  preferences() {
    return request<CustomerActivityPreferences>('/customer-activity/preferences');
  },

  updatePreferences(body: Partial<CustomerActivityPreferences>) {
    return request<CustomerActivityPreferences>('/customer-activity/preferences', {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
  },
};
